import _classCallCheck from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import Zone from "../zone.js";

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inherits(InvalidZone, _Zone);
  var _super = _createSuper(InvalidZone);
  function InvalidZone(zoneName) {
    var _this;
    _classCallCheck(this, InvalidZone);
    _this = _super.call(this);
    /**  @private */
    _this.zoneName = zoneName;
    return _this;
  }

  /** @override **/
  _createClass(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }

    /** @override **/
  }, {
    key: "offsetName",
    value: function offsetName() {
      return null;
    }

    /** @override **/
  }, {
    key: "formatOffset",
    value: function formatOffset() {
      return "";
    }

    /** @override **/
  }, {
    key: "offset",
    value: function offset() {
      return NaN;
    }

    /** @override **/
  }, {
    key: "equals",
    value: function equals() {
      return false;
    }

    /** @override **/
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);
  return InvalidZone;
}(Zone);
export { InvalidZone as default };